const OneTimePassCode = () => {
	const handleOTPPaste = (e) => {
		var clipboardData, pastedData;
		e.preventDefault();
		e.stopPropagation();

		clipboardData = e.clipboardData || window.clipboardData;
		pastedData = clipboardData.getData('Text');

		document.getElementById('code1').value = pastedData[0];
		document.getElementById('code2').value = pastedData[1];
		document.getElementById('code3').value = pastedData[2];
		document.getElementById('code4').value = pastedData[3];
		document.getElementById('code5').value = pastedData[4];
		document.getElementById('code6').value = pastedData[5];
	};

	const moveFocus = (e, fieldId, nextField, prevField = '') => {
		const value = e.target.value;

		if (e.key === 'Backspace' && value == '' && prevField) {
			document.getElementById(prevField).focus();
		}

		if (value) {
			document.getElementById(nextField).focus();
		}
	};

	const handleBack = (event, prevField) => {
		if (event.key === 'Backspace' && event.target.value == '') {
			document.getElementById(prevField).focus();
		}
	};

	return (
		<div className="flex">
			<input
				type="text"
				inputMode="numeric"
				pattern="[0-9]"
				autoComplete="one-time-code"
				maxLength="1"
				className="ml-10 mr-10 uppercase otp-code-input"
				required
				placeholder=""
				onKeyDown={(e) => handleBack(e, '')}
				onChange={(e) => moveFocus(e, 'code1', 'code2')}
				onPaste={handleOTPPaste}
				id="code1"
			/>
			<input
				type="text"
				inputMode="numeric"
				pattern="[0-9]"
				maxLength="1"
				className="ml-10 mr-10 uppercase otp-code-input"
				required
				placeholder=""
				onKeyDown={(e) => handleBack(e, 'code1')}
				onChange={(e) => moveFocus(e, 'code2', 'code3')}
				id="code2"
			/>
			<input
				type="text"
				inputMode="numeric"
				pattern="[0-9]"
				maxLength="1"
				className="ml-10 mr-10 uppercase otp-code-input"
				required
				placeholder=""
				onKeyDown={(e) => handleBack(e, 'code2')}
				onChange={(e) => moveFocus(e, 'code3', 'code4')}
				id="code3"
			/>
			<input
				type="text"
				inputMode="numeric"
				pattern="[0-9]"
				maxLength="1"
				className="ml-10 mr-10 uppercase otp-code-input"
				required
				placeholder=""
				onKeyDown={(e) => handleBack(e, 'code3')}
				onChange={(e) => moveFocus(e, 'code4', 'code5')}
				id="code4"
			/>
			<input
				type="text"
				inputMode="numeric"
				pattern="[0-9]"
				maxLength="1"
				className="ml-10 mr-10 uppercase otp-code-input"
				required
				placeholder=""
				onKeyDown={(e) => handleBack(e, 'code4')}
				onChange={(e) => moveFocus(e, 'code5', 'code6')}
				id="code5"
			/>
			<input
				type="text"
				inputMode="numeric"
				pattern="[0-9]"
				maxLength="1"
				className="ml-10 mr-10 uppercase otp-code-input"
				required
				placeholder=""
				onKeyDown={(e) => handleBack(e, 'code5')}
				id="code6"
			/>
		</div>
	);
};
export default OneTimePassCode;
